import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { select } from '@ngxs/store';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { PortalInviteDispatch } from 'src/app/shared/state/portal-invite/portal-invite.dispatch';
import { SectionComponent } from 'src/app/ui/section/section.component';
import { UiModule } from 'src/app/ui/ui.module';
import { ClientDropdownItem } from '../../view-models/models';
import { $shareIntakeFormModalViewModel } from '../../view-models/selectors';
import { IntakeClientPillComponent } from '../intake-client-pill/intake-client-pill.component';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';

@Component({
	selector: 'app-intake-side-panel',
	templateUrl: './intake-side-panel.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		SectionComponent,
		IntakeClientPillComponent,
		UiModule,
		AtomicModule,
		CommonModule,
	],
})
export class IntakeSidePanelComponent {
	viewModel_ = select($shareIntakeFormModalViewModel);
	private portalInviteDispatch = inject(PortalInviteDispatch);
	private analyticsService = inject(AnalyticsService);

	addClientEditAccess($event: DropdownResult<ClientDropdownItem>) {
		this.portalInviteDispatch.AddInvitees({
			inviteId: this.viewModel_().portalInvite.id,
			invitees: [$event.result.value],
		});

		this.analyticsService.logEvent(
			AnalyticsEvent.INTAKE_PARTIES_INTAKE_OVERVIEW_SHARE_ADD,
		);
	}
}
